
import React, { useState, useEffect } from 'react';
import {
  Box, Typography, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, Skeleton,
  Card, CardContent, Tooltip
} from '@mui/material';
import { useQuery } from 'react-query';
import axios from 'axios';
import { baseUrl, config, requestID } from '../../../common/utils';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip as RechartsTooltip, Legend } from 'recharts';
import { 
  TrendingUp, TrendingDown, TrendingFlat, 
  CheckCircle, Warning, Error as ErrorIcon,
  Inventory, ShoppingCart, Warehouse
} from '@mui/icons-material';
import styles from './vendor-performance.module.css';
import { IonContent, IonHeader, IonPage } from '@ionic/react';

const fetchVendorPerformance = async () => {
  const payload = { requestID: requestID() };
  const response = await axios.post(`${baseUrl()}vendors/getAllVendorsPerformance`, payload, config);

  return response.data.data;
};


const VendorPerformance: React.FC = () => {
  const { data, isLoading, error } = useQuery('vendorPerformance', fetchVendorPerformance);
  const [animateTable, setAnimateTable] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState<any>(null);

  useEffect(() => {
    if (data) {
      setAnimateTable(true);
    }
  }, [data]);

  // Performance level determination
  const getPerformanceLevel = (percentage: number) => {
    if (percentage < 30) return 'low';
    if (percentage < 70) return 'medium';
    return 'high';
  };

  // Performance icon based on level
  const getPerformanceIcon = (level: string) => {
    switch (level) {
      case 'low':
        return <ErrorIcon className={styles.performanceLow} />;
      case 'medium':
        return <Warning className={styles.performanceMedium} />;
      case 'high':
        return <CheckCircle className={styles.performanceHigh} />;
      default:
        return <TrendingFlat />;
    }
  };


    
    const calculateSelectedVendorStats = () => {
        if (!selectedVendor) return { totalSupplied: 0, totalRequested: 0, totalLeft: 0, avgPerformance: 0 };
        
        const vendorData = data.find((vendor: any) => vendor.vendor_id === selectedVendor);
        if (!vendorData) return { totalSupplied: 0, totalRequested: 0, totalLeft: 0, avgPerformance: 0 };
        
        const totalSupplied = vendorData.total_supplied;
        const totalRequested = vendorData.total_requested;
      // const totalLeft = vendorData.total_quantity_left;
        const totalLeft = totalRequested - totalSupplied;
        
        const avgPerformance = totalSupplied > 0 
            ? Math.round((totalSupplied / totalRequested) * 100) 
            : 0;
        
        return { totalSupplied, totalRequested, totalLeft, avgPerformance };
        }

  // Prepare pie chart data
  const preparePieChartData = () => {
    if (!data || data.length === 0) return [];
    console.log('Data:', data);
    return data.map((vendor: any) => {
      const performance = vendor.total_supplied > 0
        ? Math.round((vendor.total_supplied / vendor.total_requested) * 100)
              : 0;
        // const performance = 100;
        
        console.log('Performance:', performance);
      
      return {
        name: vendor.fullname || `Vendor ${vendor.vendor_id}`,
        value: performance,
        color: getPerformanceColor(performance)
      };
    });
  };

  // Get color based on performance percentage
  const getPerformanceColor = (percentage: number) => {
    const level = getPerformanceLevel(percentage);
    switch (level) {
      case 'low':
        return '#cf6679';
      case 'medium':
        return '#ffb74d';
      case 'high':
        return '#4caf50';
      default:
        return '#bb86fc';
    }
  };

  // Loading skeleton component
  const LoadingSkeleton = () => (
    <Box className={styles.container} p={3}>
      <Skeleton variant="text" width={300} height={40} className={styles.skeleton} />
      
      <Box className={styles.statsContainer}>
        {[1, 2, 3, 4].map((item) => (
          <Skeleton 
            key={item}
            variant="rectangular" 
            height={100} 
            className={styles.skeleton} 
            style={{ borderRadius: '8px' }}
          />
        ))}
      </Box>
      
      <Box className={styles.dashboardContainer}>
        <Skeleton 
          variant="rectangular" 
          height={400} 
          className={styles.skeleton} 
          style={{ borderRadius: '8px' }}
        />
        <Skeleton 
          variant="rectangular" 
          height={400} 
          className={styles.skeleton} 
          style={{ borderRadius: '8px' }}
        />
      </Box>
    </Box>
  );

  if (isLoading) return <LoadingSkeleton />;
  if (error) return <Typography color="error" className={styles.container} p={3}>Failed to load data.</Typography>;

    //   const stats = calculateStats()
    const stats = calculateSelectedVendorStats();
  const pieChartData = preparePieChartData();

  return (

    <IonPage>
      <IonHeader className="ion-no-border">
      <Typography variant="h5" className={`${styles.title} ${styles.fadeIn}`}>
        Vendors Performance Dashboard
      </Typography>
      </IonHeader>
        {/* <IonContent className="ion-no-border"> */}

<IonContent>

<Box className={styles.container1} p={3} sx={{ width: '100%' }}>
     
{/* 
      <Box className={`${styles.statsContainer} ${styles.fadeIn} ${styles.fadeIn1}`}>
        <Card className={styles.statCard}>
          <CardContent>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography className={styles.statTitle}>Total Supplied</Typography>
              <Box className={styles.iconContainer} style={{ backgroundColor: 'rgba(187, 134, 252, 0.1)' }}>
                <Inventory style={{ color: '#bb86fc' }} fontSize="small" />
              </Box>
            </Box>
            <Typography className={styles.statValue}>{stats.totalSupplied}</Typography>
          </CardContent>
        </Card>
        
        <Card className={styles.statCard}>
          <CardContent>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography className={styles.statTitle}>Total Requested</Typography>
              <Box className={styles.iconContainer} style={{ backgroundColor: 'rgba(76, 175, 80, 0.1)' }}>
                <ShoppingCart style={{ color: '#4caf50' }} fontSize="small" />
              </Box>
            </Box>
            <Typography className={styles.statValue}>{stats.totalRequested.toLocaleString()}</Typography>
          </CardContent>
        </Card>
        
        <Card className={styles.statCard}>
          <CardContent>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography className={styles.statTitle}>Total Left</Typography>
              <Box className={styles.iconContainer} style={{ backgroundColor: 'rgba(255, 183, 77, 0.1)' }}>
                <Warehouse style={{ color: '#ffb74d' }} fontSize="small" />
              </Box>
            </Box>
            <Typography className={styles.statValue}>{stats.totalLeft.toLocaleString()}</Typography>
          </CardContent>
        </Card>
        
        <Card className={styles.statCard}>
          <CardContent>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography className={styles.statTitle}>Avg. Performance</Typography>
              <Box className={styles.iconContainer} style={{ 
                backgroundColor: `rgba(${getPerformanceColor(stats.avgPerformance).replace('#', '').match(/.{2}/g)?.map(hex => parseInt(hex, 16)).join(', ')}, 0.1)` 
              }}>
                {stats.avgPerformance > 50 ? 
                  <TrendingUp style={{ color: getPerformanceColor(stats.avgPerformance) }} fontSize="small" /> : 
                  <TrendingDown style={{ color: getPerformanceColor(stats.avgPerformance) }} fontSize="small" />
                }
              </Box>
            </Box>
            <Typography className={styles.statValue}>{stats.avgPerformance}%</Typography>
          </CardContent>
        </Card>
      </Box> */}

      <Box className={`${styles.fadeIn} ${styles.fadeIn2}`}>
        <TableContainer component={Paper} className={styles.tableContainer} sx={{ width: '100%' }}>

          <Table>
            <TableHead className={styles.tableHead}>
              <TableRow>
                <TableCell className={styles.tableHeadCell}>S/N</TableCell>
                {/* <TableCell className={styles.tableHeadCell}>Vendor ID</TableCell> */}
                <TableCell className={styles.tableHeadCell}>Vendor Name</TableCell>
                <TableCell className={styles.tableHeadCell}>Total Supplied</TableCell>
                <TableCell className={styles.tableHeadCell}>Total Requested</TableCell>
                <TableCell className={styles.tableHeadCell}>Total Left</TableCell>
                <TableCell className={styles.tableHeadCell}>Performance</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((vendor: any, index: number) => {
                const performance = vendor.total_supplied > 0
                  ? Math.round((vendor.total_supplied / vendor.total_requested) * 100)
                  : 0;
                
                const totalLeft = vendor.total_requested - vendor.total_supplied;
                
                const performanceLevel = getPerformanceLevel(performance);
                
                return (
                  <TableRow key={index} className={styles.tableRow}>
                    <TableCell className={styles.tableCell}>{index + 1}</TableCell>
                    {/* <TableCell className={styles.tableCell}>{vendor.vendor_id}</TableCell> */}
                    <TableCell 
                    className={`${styles.tableCell} 
                    ${styles.vendorName}`}
                    onClick={() => setSelectedVendor(vendor.vendor_id)}
                        >
                      {vendor.fullname || 'N/A'}
                    </TableCell>
                    <TableCell className={styles.tableCell}>{vendor.total_supplied?.toLocaleString()}</TableCell>
                    <TableCell className={styles.tableCell}>{vendor.total_requested?.toLocaleString()}</TableCell>
                    <TableCell className={styles.tableCell}>{totalLeft?.toLocaleString()}</TableCell>
                    <TableCell className={styles.tableCell}>
                      <Box>
                        <Box className={styles.performanceText}>
                          {getPerformanceIcon(performanceLevel)}
                          <Typography 
                            className={`${styles[`performance${performanceLevel.charAt(0).toUpperCase() + performanceLevel.slice(1)}`]}`}
                          >
                            {performance}%
                          </Typography>
                        </Box>
                        <Tooltip title={`${performance}% Performance`}>
                          <Box className={styles.performanceBar}>
                            <Box 
                              className={`${styles.performanceFill} ${styles[`fill${performanceLevel.charAt(0).toUpperCase() + performanceLevel.slice(1)}`]}`} 
                              style={{ width: `${performance}%` }}
                            />
                          </Box>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

     {/*    <Card className={`${styles.chartContainer} ${styles.fadeIn} ${styles.fadeIn3}`}>
          <Typography className={styles.chartTitle}>
            Vendor Performance Distribution
          </Typography>
          <Box className={styles.pieChartContainer}>
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={pieChartData}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  outerRadius={80}
                  fill="#8884d8"
                  dataKey="value"
                // label={({ name, value }) => `${name}: ${value}%`}
                  
                >
                  {pieChartData.map((entry: any, index: number) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
                <Legend />
              
                              <RechartsTooltip
  formatter={(value: any, name: any, props: any) => [`${value}%`, props.payload.name]}
/>

              </PieChart>
            </ResponsiveContainer>
          </Box>
        </Card> */}
      </Box>
    </Box>
    </IonContent>

    </IonPage>

  );
};

export default VendorPerformance;